// GLSL for WallMist: the curtain strip and the drifting wall wisps.
// All motion is a function of `uTime`; `uLight` dims the mist at night.

/** Curtain: a tall alpha-gradient strip along the board edge (attrs aA, aH). */
export const CURTAIN_VERT = /* glsl */ `
  attribute float aA;
  attribute float aH;
  varying float vA;
  varying float vH;
  varying vec3 vW;
  void main() {
    vA = aA;
    vH = aH;
    vW = position;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const CURTAIN_FRAG = /* glsl */ `
  uniform float uTime;
  uniform float uLight;
  uniform vec3 uColor;
  varying float vA;
  varying float vH;
  varying vec3 vW;
  float n2(vec2 p) {
    return 0.5 + 0.5 * sin(p.x * 1.7 + sin(p.y * 1.3 + uTime * 0.12) * 1.6)
                     * sin(p.y * 1.1 + sin(p.x * 0.9 - uTime * 0.09) * 1.4);
  }
  void main() {
    // Banks of denser mist drifting slowly along the wall.
    float bank = n2(vW.xz * 0.55 + vec2(uTime * 0.04, 0.0));
    float wisp = n2(vW.xz * 1.9 + vec2(0.0, uTime * 0.07) + vW.y);
    float a = vA * (0.55 + 0.45 * bank) * (0.75 + 0.25 * wisp);
    gl_FragColor = vec4(uColor * uLight, clamp(a, 0.0, 0.92));
  }
`;

/** Wisp: camera-facing soft puff, drifting along the wall and fading in/out. */
export const WISP_VERT = /* glsl */ `
  uniform float uTime;
  varying vec2 vUv;
  varying float vFade;
  varying float vPhase;
  void main() {
    vUv = uv;
    vec3 c = instanceMatrix[3].xyz;
    vPhase = fract(sin(dot(c.xz, vec2(12.9898, 78.233))) * 43758.5453);
    float cyc = fract(uTime * (0.025 + vPhase * 0.02) + vPhase);
    vFade = sin(cyc * 3.14159);
    c.x += (cyc - 0.5) * 1.6;
    c.z += sin(vPhase * 6.28 + cyc * 3.0) * 0.4;
    c.y += vFade * 0.15;
    float size = length(instanceMatrix[0].xyz) * (0.85 + 0.3 * vFade);
    vec4 mv = modelViewMatrix * vec4(c, 1.0);
    mv.xy += position.xy * size;
    gl_Position = projectionMatrix * mv;
  }
`;

export const WISP_FRAG = /* glsl */ `
  uniform float uLight;
  uniform vec3 uColor;
  varying vec2 vUv;
  varying float vFade;
  varying float vPhase;
  void main() {
    vec2 d = vUv - 0.5;
    float r = length(d) * 2.0;
    float soft = smoothstep(1.0, 0.05, r);
    gl_FragColor = vec4(uColor * uLight, soft * soft * vFade * 0.5);
  }
`;
